export enum TabKey {
  BRIDGE = 'BRIDGE',
  AWAIT_RESPONSE = 'AWAIT_RESPONSE',
  FULLY_SUPPORTED = 'FULLY_SUPPORTED',
  MIXER = 'MIXER',
  COLLABORATOR = 'COLLABORATOR',
}
